module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/header.066ebcbc.png";